import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class VideoService {

  public videoElement:any;
  //this.iosVersion = window["iOSversion"]();
  public currentPath:string = '';
  public currentTitle:string = "content is loading...";
  public currentDesc:string = '';
  //public currentPath:string = "./assets/video/PanoRoofLube_Sample_768Kbps_848x476_angularVP_001.mp4";
  //public currentTitle:string = "AKUBIS<sup>&reg;</sup> 205: Clean &amp; Lubricate Panorama Roof";//"loading...";
  //public currentDesc:string = "<h5>Cleaning and lubrication of the guide mechanism of the panorama roof in model 205.</h5>";//"AKUBIS loading...";
  public currentTime:number = 0;
  public totalTime:number = 0;
  public videoRect:any;
  
  public downloadProgress:number = null;
  public calculatedWidth:number;
  public calculatedScrubY:number;
  public isMuted:boolean = false;
  public isPlaying:boolean = false;
  public isDragging:boolean = false;
  public showDetails:boolean = false;
  public showMenu:boolean = false;
  public playlist:Array<Object> = [];
  public playlistBackup:Array<Object> =[];
  public searchBox:any;
  public searchBar:any;
  public hideSearchDelay:any;
  public wasPausedDuringPlayback:boolean = false;
  public userHasInteracted:boolean = false;
  public userHasToggledFullscreen:boolean = false;
  public loadComplete:boolean = false;
  public videoPlayedToEnd:boolean = false;

  
  constructor(private _http:Http) {}

  appSetup(v:string) {
    console.log("appSetup: "+v);
    /*
    this.currentPath = "./video/cow.mp4";
    this.currentTitle = "Cow";
    this.currentDesc = "A cow."
    */

    this.currentPath = window["videoPath"];
    this.currentTitle = window["videoTitle"];
    this.currentDesc = window["videoDesc"];
    
    this.videoElement = <HTMLVideoElement> document.getElementById(v);
    window["makeVideoPlayableInline"](this.videoElement);
    this.videoElement.addEventListener("loadedmetadata", this.updateData);
    this.videoElement.addEventListener("timeupdate", this.updateTime);
    this.videoElement.addEventListener("progress", this.updateDownloadProgress, true);  
    window.addEventListener("orientationchange", function() {
            
            if(screen["orientation"].angle == 90){
                window.scrollTo(0, 5);
                //alert("the orientation of the device is now " + screen["orientation"].angle);
            }
            if(screen["orientation"].angle == 0){
                window.scrollTo(0, 0);
                //alert("the orientation of the device is now " + screen["orientation"].angle);
            }
            
            
        });
    window.setInterval(this.timerFired, 10);
    
  }
  
  updateData = (e:any) => {
      this.totalTime = this.videoElement.duration;
  };

  updateTime = (e:any) => {
      this.currentTime = this.videoElement.currentTime;
  };

  updateDownloadProgress = (e:any) => {
      //needed this function for the timerFired percentages to work.
  }

  
  timerFired = () => {
    this.videoRect = this.videoElement.getBoundingClientRect();
        //console.log(this.videoRect.top, this.videoRect.right, this.videoRect.bottom, this.videoRect.left);
   
    
    if(!this.isDragging) {
      //this.calculatedScrubY = rect.top + this.videoElement.offsetHeight;
      this.calculatedScrubY = this.videoRect.bottom;
      var t = this.videoElement.currentTime;
      var d = this.videoElement.duration;
      if(t == d){
        if(!this.videoPlayedToEnd){
            this.videoPlayedToEnd = true;
            console.log("Video has played to end");
            window['ga']('send', 'event', 'Video Playback Event', 'Video has played to end', this.currentPath);
        }
      }
      this.calculatedWidth = (t / d * this.videoElement.offsetWidth);
    }
     if(!this.loadComplete){
       if(t>1){
           this.calculateDownload();
       }
        
    } 

  };

  gatherJSON = () => {
      this._http.get('./assets/data/playlist.json')
          .map((res:Response) => res.json())
          .subscribe(
              data => {
                  this.playlist = data;
                  this.playlistBackup = data;
                  this.selectedVideo(0);
                  console.log(this.playlist);
              }
          );
  };

  selectedVideo = (i:number) => {
      this.videoElement.pause();
      this.isPlaying = false;
      this.videoElement.currentTime = 0;
      this.currentTime = 0;

      this.currentTitle = this.playlist[i]['title'];
      this.currentDesc = this.playlist[i]['description'];
      this.videoElement.src = this.playlist[i]['path'];
      window.scrollTo(0, 0);
  };

  calculateDownload(){
    var vid = this.videoElement;
    //console.log("vid.buffered.length= ",vid.buffered.length);
    var current_buffers_length = vid.buffered.length;
    var bufferGroup = new Array();
    var bufferArrayTimes = new Array();
    for(var i = 0; i < current_buffers_length; i++){

        //bufferGroup = vid.buffered.end(i) - vid.buffered.start(i);
        bufferGroup.push(vid.buffered.start(i));
        bufferGroup.push(vid.buffered.end(i));
        bufferArrayTimes.push(bufferGroup);

    }
    var lastItemInBuffer = bufferArrayTimes[0].length-1;
    var amountLoaded = bufferArrayTimes[0][lastItemInBuffer];
    //console.log("bufferArrayTime",bufferArrayTimes[0]);
    //console.log("amountLoaded",amountLoaded);
    var d = vid.duration;
    var percent = amountLoaded / d;
    //console.log("percent ", percent);
    if(!this.loadComplete && percent > .98){
        this.loadComplete = true;
        console.log("loadComplete");
        window['ga']('send', 'event', 'Video Loading Event', 'Video download completed', this.currentPath);
    }
  }

  selectedAndToggleVideo(i:number){
      this.selectedVideo(i);
      this.toggleMenu();
  }

  userInteracted(){
      if(!this.userHasInteracted){
          console.log("user has interacted with the page");
          this.userHasInteracted = true;
          window['ga']('send', 'event', 'Video Playback Event', 'User has begun video', this.currentPath);
      }
  }

  seekVideo(e:any) {
      var w = document.getElementById('progressMeterFull').offsetWidth;
      var d = this.videoElement.duration;
      var s = Math.round((e.pageX-this.videoRect.left) / w * d);
      this.videoElement.currentTime = s;
      this.userInteracted();
  };

  dragStart = function(e:any) {
      this.isDragging = true;
  };
  dragMove = function(e:any) {
      if(this.isDragging){
          this.calculatedWidth = e.x;
      }
  };
  dragStop = function(e:any) {
      if(this.isDragging){
          this.isDragging = false;
          this.seekVideo(e);
      }
  };

  muteVideo() {
      

      //if(this.videoElement.volume == 0) {
      if(this.videoElement.muted) {
          this.videoElement.muted = false;
          //this.videoElement.volume = 1;
          this.isMuted = false;
      }else{
          this.videoElement.muted = true;
          //this.videoElement.volume = 0;
          this.isMuted = true;
      }
     
  };

  showPauseToggle(){
      console.log("showPauseToggle");
     // this.videoElement.currentTime = this.videoElement.duration-5;
      this.isPlaying = false;
  }


  playVideo() {
      this.userInteracted();

      if(this.videoElement.paused) {
          this.videoElement.play();
          this.isPlaying = true;
          if(this.showDetails){
              this.showDetails = false;
          }
      }else{
          this.videoElement.pause();
          this.isPlaying = false;
      }
  };

  details() {
      if(this.showDetails == false){
          this.showDetails = true;
          if(this.isPlaying){
             this.wasPausedDuringPlayback = true;
             this.playVideo(); 
          }
      }else{
          
          this.showDetails = false;
          if(!this.isPlaying && this.wasPausedDuringPlayback){
             this.wasPausedDuringPlayback = false;
             this.playVideo(); 
          }
          
      }
  };

  

  fullScreen() {
      if(this.videoElement.requestFullscreen) {
          this.videoElement.requestFullscreen();
      }else if(this.videoElement.mozRequestFullScreen) {
          this.videoElement.mozRequestFullScreen();
      }else if(this.videoElement.webkitRequestFullscreen) {
          this.videoElement.webkitRequestFullscreen();
      }else if(this.videoElement.msRequestFullscreen) {
          this.videoElement.msRequestFullscreen();
      }
      if(!this.userHasToggledFullscreen){
        this.userHasToggledFullscreen = true;
        window['ga']('send', 'event', 'Video Playback Event', 'User has toggled fullscreen mode', this.currentPath);
      }
  };

  toggleMenu(){
        this.showMenu = !this.showMenu;
        var menuList = document.getElementById('menu-list-panel');
        var menuShadow = document.getElementById('insetDiv');
        this.searchBar = document.getElementById('searchList');
        window.clearTimeout(this.hideSearchDelay);
        if(this.showMenu){
             //document.body.style.overflow = "hidden";
             //document.documentElement.style.overflow = "hidden";
             //display: inline-block;
             menuList.scrollTop = 0;
             this.searchBar["style"].display = "inline-block";
             menuList["style"].height = "38vh";
             menuShadow["style"].height = "38vh";

        }else{
            //document.body.style.overflow = "scroll";
            //document.documentElement.style.overflow = "scroll";
            //this.searchBar["style"].display = "none";
            menuList["style"].height = "0vh";
            menuShadow["style"].height = "0vh";
            //this.hideSearchDelay = window.setTimeout(this.delayedHideSearch, 150);

        }
  }

  delayedHideSearch(){
      var searchBar = document.getElementById('searchList');
      searchBar["style"].display = "none";
  }

  getSearchItems(event:any) {
	// set val to the value of the ev target
    
	var val = event.target.value;
    console.log(val);
    /*
    if(this.playlist != this.playlistBackup){
        this.playlist = this.playlistBackup;
    }
    */
    this.playlist = new Array();
    this.playlist = this.playlistBackup.slice(0);
    
    // if the value is an empty string don't filter the items
	if (val && val.trim() != '') {
        this.playlist = this.playlist.filter((item) => {
            return (item['title'].toLowerCase().indexOf(val.toLowerCase()) > -1);
        })
    }

    
  }
  

}


// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/video.service.ts